import { ComponentType, SVGProps } from "react";
import { PoparceLogo } from "src/components/Icons";

export interface LegalDocuments {
  OFFER: string;
  PRIVACY_POLICY: string;
  CONSENT_PERSONAL_DATA?: string;
  CONSENT_MARKETING?: string;
  COOKIE_POLICY?: string;
}

export interface AppConfig {
  id: string;

  appName: string;
  displayName: string;

  domain: string;
  url: string;

  docsUrl: string;

  contactEmail: string;

  logo: ComponentType<SVGProps<SVGSVGElement>>;

  telegramBotUsername: string;

  legalDocuments: LegalDocuments;
}

const POPARCE_LEGAL_URL_BASE = "https://s3.twcstorage.ru/poparce-public";

export const appConfig: AppConfig = {
  id: "poparce",
  appName: "poparce",
  displayName: "Poparce",

  domain: "poparce.ru",
  url: "https://poparce.ru/",
  docsUrl: "https://poparce.ru/docs/",

  contactEmail: "contact@poparce.ru",

  logo: PoparceLogo,

  telegramBotUsername: "PoparceBot",

  legalDocuments: {
    OFFER: `${POPARCE_LEGAL_URL_BASE}/public-offer.pdf`,
    PRIVACY_POLICY: `${POPARCE_LEGAL_URL_BASE}/privacy-policy.pdf`,
    CONSENT_PERSONAL_DATA: `${POPARCE_LEGAL_URL_BASE}/consent-personal-data.pdf`,
    CONSENT_MARKETING: `${POPARCE_LEGAL_URL_BASE}/consent-marketing.pdf`,
    COOKIE_POLICY: `${POPARCE_LEGAL_URL_BASE}/cookie-policy.pdf`,
  },
};
